(function () {
  // Prevent double-initialization if the file loads twice
  if (window.__ppMiniCartInit) return;
  window.__ppMiniCartInit = true;

  function getConsentInput() {
    return document.getElementById("checkbox-cart-policy-consent-mini-cart");
  }
  function consentOk() {
    var c = getConsentInput();
    return !c || !!c.checked;
  }

  function setLoading(isLoading, scopeEl) {
    (scopeEl || document).querySelectorAll('[data-pp-action]').forEach(function (el) {
      el.disabled = !!isLoading;
      el.setAttribute("aria-busy", isLoading ? "true" : "false");
    });
  }

  function tierVariantForSubtotalCents(subtotalCents, t1, t2, t3, t4) {
    var c = Number(subtotalCents || 0);
    if (c < 5000) return t1;   // < $50
    if (c < 10000) return t2;  // < $100
    if (c < 20000) return t3;  // < $200
    return t4;                 // >= $200
  }

  async function fetchCart() {
    var res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to load cart");
    return await res.json();
  }

  function subtotalExcludingProtection(cart, protectionProductId) {
    var sum = 0;
    (cart.items || []).forEach(function (item) {
      if (Number(item.product_id) === Number(protectionProductId)) return;
      sum += Number(item.final_line_price || 0);
    });
    return sum;
  }

  async function removeAllProtectionLines(cart, protectionProductId) {
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (Number(item.product_id) === Number(protectionProductId)) {
        updates[item.key] = 0;
      }
    });
    if (!Object.keys(updates).length) return;

    var res = await fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ updates: updates }),
    });
    if (!res.ok) throw new Error("Failed to remove protection");
  }

  async function addVariantQty1(variantId) {
    var res = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
    if (!res.ok) throw new Error("Failed to add protection");
  }

  function goCheckout() {
    window.location.href = "/checkout";
  }

  document.addEventListener("click", async function (e) {
    var btn = e.target.closest('[data-pp-action]');
    if (!btn) return;

    var footer = btn.closest(".mini-cart-footer");
    if (!footer) return;

    var wrap = footer.querySelector(".mini-cart-footer-actions--pp");
    if (!wrap) return;

    if (!consentOk()) {
      var c = getConsentInput();
      if (c) c.reportValidity();
      return;
    }

    var action = btn.getAttribute("data-pp-action");

    var protectionProductId = Number(wrap.getAttribute("data-pp-product-id"));
    var t1 = Number(wrap.getAttribute("data-pp-t1"));
    var t2 = Number(wrap.getAttribute("data-pp-t2"));
    var t3 = Number(wrap.getAttribute("data-pp-t3"));
    var t4 = Number(wrap.getAttribute("data-pp-t4"));

    try {
      setLoading(true, footer);

      var cart = await fetchCart();

      if (action === "with") {
        // remove existing protection
        await removeAllProtectionLines(cart, protectionProductId);

        // re-fetch after mutation
        var cart2 = await fetchCart();

        var subtotal = subtotalExcludingProtection(cart2, protectionProductId);
        var tierVariantId = tierVariantForSubtotalCents(subtotal, t1, t2, t3, t4);

        // add protection last
        await addVariantQty1(tierVariantId);

        goCheckout();
        return;
      }

      if (action === "without") {
        await removeAllProtectionLines(cart, protectionProductId);
        goCheckout();
        return;
      }
    } catch (err) {
      console.error("[PP] minicart error:", err);
      goCheckout();
    } finally {
      setLoading(false, footer);
    }
  });
})();
